import { useSeekaConverge } from "@seeka-labs/converge-react";
import { Box, Flex, PrimaryButton, LegacyText, SelectOption } from "flicket-ui";
import { Select } from "~components";
import { useSeatedReservationStore } from "~features/seated-reservation/store";
import * as actions from "~features/seated-reservation/store/actions/index";

type OptionsProps = {
  handleClose: () => void;
  seatAmountOptions: SelectOption[];
};

export const Options = ({ handleClose, seatAmountOptions }: OptionsProps) => {
  const converge = useSeekaConverge();

  const chartReady = useSeatedReservationStore((state) => state.chartReady);
  const options = useSeatedReservationStore((state) => state.options);

  const updateOptions = async (key, value) =>
    actions.updateOptions({ options: { [key]: value } }, converge);
  return (
    <Flex flexDir="column" width="100%" p={{ _: 2, md: 0 }}>
      <Box>
        <LegacyText fontWeight="extraBold" color="N800" fontSize={2} mb="6/4">
          I need tickets for
        </LegacyText>
        <Select
          value={seatAmountOptions.find(
            (o) => o.value === String(options.amount)
          )}
          onChange={(value) => {
            void updateOptions("amount", value);
          }}
          options={seatAmountOptions}
          mb={5}
          isDisabled={!chartReady}
          isSearchable={false}
        />
      </Box>

      <PrimaryButton mt={3} mb={5} onClick={handleClose} width="100%">
        Select seat{options.amount > 1 ? "s" : ""}
      </PrimaryButton>
    </Flex>
  );
};
